module.exports = __webpack_public_path__ + "img/checking.b95c1226.svg";